import { Theme } from "@amx/ux-twoui-theming";

export const getFallbackIconWrapperStyles = (theme: Theme, height: number, width: number, useBackPlate: boolean) => {
    return ({
        root: {
            height: height,
            width: width,
            backgroundColor: useBackPlate ? theme.palette.neutralLighter : "transparent",
        }
    });
};
